import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, KeyRound } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PortailLogin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [reference, setReference] = useState("");
  const [birth, setBirth] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/portail/login`, { reference, date_naissance: birth }, { withCredentials: true });
      localStorage.setItem("d2r_player", data.token);
      navigate("/portail/accueil");
    } catch (err) {
      setError(err.response?.data?.detail || t("portal.login.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <img src="/assets/logo-dark-sm.png" alt="DREAM2REALITY" className="h-16 w-auto mx-auto mb-6" />
        <p className="text-center text-[#C5A059] text-[10px] uppercase tracking-[0.4em] mb-3" data-testid="portail-edition">{t("portal.edition")}</p>
        <h1 className="font-display text-3xl uppercase font-bold text-center text-white">
          {t("portal.login.title")}
        </h1>
        <p className="text-center text-[#71717A] text-sm mt-2">{t("portal.login.sub")}</p>
        <form onSubmit={submit} data-testid="portail-login-form" className="mt-10 bg-[#121214] border border-[#27272A] p-8 space-y-8">
          <input
            data-testid="portail-input-reference"
            type="text"
            required
            autoComplete="off"
            placeholder={t("portal.login.ref")}
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            className="input-editorial uppercase"
          />
          <input
            data-testid="portail-input-birthdate"
            type="date"
            required
            value={birth}
            onChange={(e) => setBirth(e.target.value)}
            className="input-editorial [color-scheme:dark]"
            aria-label={t("portal.login.birth")}
          />
          {error && <p data-testid="portail-login-error" className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            data-testid="portail-login-submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[#C5A059] text-black py-3.5 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-[#E5C07B] transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 size={15} className="animate-spin" /> : <KeyRound size={15} />}
            {t("portal.login.submit")}
          </button>
        </form>
        <div className="flex justify-between items-center mt-6 text-xs">
          <Link to="/" data-testid="portail-back-to-site" className="text-[#71717A] hover:text-[#C5A059] transition-colors">← DREAM2REALITY</Link>
          <Link to="/admin" data-testid="portail-admin-link" className="text-[#A1A1AA] hover:text-[#C5A059] transition-colors">{t("portal.login.admin")}</Link>
        </div>
      </div>
    </div>
  );
}
